  <app-hero id="hero"></app-hero>
  <app-about id="about"></app-about>
  <app-services id="services"></app-services>
  <app-projects id="projects"></app-projects>
  <app-testimonials id="testimonials"></app-testimonials>
  <app-technologies id="technologies"></app-technologies>
  <app-contact id="contact"></app-contact>
  <app-signalbot-teaser id="signalbot"></app-signalbot-teaser>
  <app-ai-chat id="chatbot"></app-ai-chat>
  <app-blog-teaser id="blog"></app-blog-teaser>
<a href="#hero" class="scroll-to-top" aria-label="Nach oben scrollen">↑</a>